
import Vue from 'vue'
import { CartItemViewModel } from '@ViewModels/CartItemViewModel'
import { Currency } from '@/components'

export default Vue.extend({
   name: 'ProductsInCartComponent',
   data() {
      return {
         submitted: false,
      }
   },
   computed: {
      cartItems(): CartItemViewModel {
         return this.$store.state.modelData.CartItems
      },
   },
   components: {
      Currency,
   },
})
